import React, { useEffect, useState } from 'react';
import bem from 'utils/bem';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import mapPin from 'components/Icon/icons/svg/map-pin--contacts.svg';
import './index.sass';

const { block, el } = bem('ya-maps');

const [ lat, lng ] = [ 55.774308, 37.594688 ];
export default ({ center }) => {

    const [ map, setMap ] = useState(null);

    useEffect(() => {
        if (map) {
            const overlay = document.createElement('div');
            overlay.classList.add(el('overlay'));
            map.panes.get('ground').getElement().insertAdjacentElement('afterend', overlay)
        }
    }, [ map ])

    return (
        <YMaps>
            <div className={ block() }>
                <Map defaultState={ { center, zoom: 16 } } instanceRef={ (node) => setMap(node) }
                     options={ { suppressMapOpenBlock: true, autoFitToViewport: 'always' } } width={ '100%' }
                     height={ '100%' }>
                    <Placemark geometry={ [ lat, lng ] }
                               options={{
                                    iconLayout: 'default#image',
                                    iconImageHref: mapPin,
                                    iconImageSize: [ 58, 58 ],
                                    iconImageOffset: [ -29, -45 ]
                               }}
                    />
                </Map>
            </div>
        </YMaps>
    )
}

